import React from "react";
import Cocktail from "./Cocktail";
import Loading from "./Loading";
import { useGlobalContext } from "../context";

export default function CocktailList() {
  const { cocktails, loading } = useGlobalContext();
  if (loading) {
    return <Loading />;
  }
  if (cocktails.length < 1) {
    return (
      <div className="error-message">
        Sorry I can't seem to find it :&#40;
      </div>
    );
  }
  return (
    <div className="cocktail-list-container">
      {cocktails.map((item) => {
        return <Cocktail key={item.id} {...item} />;
      })}
    </div>
  );
}
